import { BuildType } from './ApiService';
import {
    MintShareLinkInput,
    MintShareLinkResult,
    ShareLinkActiveList,
    ShareLinkPage,
} from '@/apiTypes/ShareLinkTypes';

export const shareLinkService = (build: BuildType) => ({
    mintShareLink: build.mutation<MintShareLinkResult, MintShareLinkInput>({
        query: body => ({
            url: 'share-links',
            method: 'POST',
            body,
        }),
        invalidatesTags: ['ShareLinks'],
    }),
    getActiveShareLinks: build.query<ShareLinkActiveList, { limit: number }>({
        query: ({ limit }) => `share-links?active=true&limit=${limit}`,
        providesTags: ['ShareLinks'],
    }),
    getShareLinksPage: build.query<ShareLinkPage, { page: number; pageSize: number }>({
        query: ({ page, pageSize }) => `share-links?page=${page}&pageSize=${pageSize}`,
        providesTags: ['ShareLinks'],
    }),
    revokeShareLink: build.mutation<void, string>({
        query: id => ({
            url: `share-links/${encodeURIComponent(id)}`,
            method: 'DELETE',
        }),
        invalidatesTags: ['ShareLinks'],
    }),
    revokeAllShareLinks: build.mutation<{ revoked: number }, void>({
        query: () => ({
            url: 'share-links/revoke-all',
            method: 'POST',
        }),
        invalidatesTags: ['ShareLinks'],
    }),
});
